module.exports = __webpack_public_path__ + "img/photo-0054.d53bc8c5.jpg";